export const contentApiPath = "/api/web-page/contents";

export type ContentResponseDTO = {
  status: number;
  message: string;
  data: any;
  isLast: boolean
};
